import { defaultTransformer } from "../utils/utils"
import { apiClient } from "./apiClient"

export const machineStatusApi = {
    /**
    * Fetch Machine Status for a given Business Entity ID and Permanent Machine Id
    * @param {string} businessEntityId - The Business Entity ID
    * @param {string} machinePermanentId - The Machine Permanent ID
    * @param {object} config - The application config object
    * @param {object} accessToken - The logged in user's accessToken
    * @returns {Promise} - The Machine Status as a Promise
    */
    fetchMachineStatus: async (businessEntityId, machinePermanentId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/machineStatus/${machinePermanentId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            defaultTransformer
        )
    }
}